import service from "./service"

const skipPreCheck = async (data) => {
    return service(data)
}

export default skipPreCheck
